import React from "react";
import "./index.scss";

const Loader = () => {
  return (
    <div className="loader_container">
      <p>Loading</p>
      <div className="loader_container__spinner"></div>
    </div>
  );
};

export default Loader;
